import Visibility from '@mui/icons-material/Visibility';
import { Box, Button, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import useWidth from '../../../components/Hooks/useWidth';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { useSignatureContext } from './contexts/signature.context';
import { ModalContractPage } from './types';

const useStyles = makeStyles()((theme) => ({
  textPrimary: {
    color: theme.palette.text.primary,
  },
  button: {
    position: 'absolute',
    bottom: theme.spacing(4),
  },
}));

const ContractSigned = () => {
  const { classes } = useStyles();
  const { changePage } = useSignatureContext();
  const { translate } = useTranslation();
  const { mobileWidth } = useWidth();
  const hasSpacing = !mobileWidth;

  const handleReadContract = () => {
    changePage(ModalContractPage.READ_CONTRACT_WITHOUT_FOOTER);
  };

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          marginBottom: 8,
        }}
      >
        <Grid container spacing={hasSpacing ? 1 : 0}>
          <Grid size={12}>
            <Typography variant={mobileWidth ? 'h6' : 'h4'} align="center">
              {translate(LangEnum.ORDER_CONTRACT_SIGNED_SUCCESS)}.
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography
              variant={mobileWidth ? 'h6' : 'h4'}
              align="center"
              className={classes.textPrimary}
            >
              {translate(LangEnum.ORDER_CONTRACT_SIGNED_TECEO_THANKS)}!
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Button
        color="primary"
        variant="outlined"
        startIcon={<Visibility />}
        className={classes.button}
        onClick={handleReadContract}
      >
        {translate(LangEnum.ORDER_CONTRACT_SIGNED_VISUALIZE)}
      </Button>
    </Box>
  );
};

export default ContractSigned;
